import { combineReducers } from 'redux';
import user from '../ducks/gateway/login/reducers';
import defaultreducder from './default/reducer'
import gateway from './gateway';

const rootReducer = combineReducers({ 
    user, defaultreducder, gateway
});

export default rootReducer;